import { Injectable } from '@angular/core';
/** Default values provider for tooltip */
export var TooltipConfig = (function () {
    function TooltipConfig() {
        /** tooltip placement, supported positions: 'top', 'bottom', 'left', 'right' */
        this.placement = 'top';
        /** array of event names which triggers tooltip opening */
        this.triggers = 'hover focus';
    }
    TooltipConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    TooltipConfig.ctorParameters = function () { return []; };
    return TooltipConfig;
}());
//# sourceMappingURL=tooltip.config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/tooltip/tooltip.config.js
// module id = 176
// module chunks = 2